import React from "react";
import { TextBoxWithFlag, Flag, Text } from "../Subtitles/TextBoxWithFlag";
import { ES } from "country-flag-icons/react/3x2";
import { UserVideoWord } from "@shared_types";
import ReviewHighlightedWords from "./ReviewHighlightedWords.tsx";

interface ReviewSubtitleProps {
  userVideoWords: UserVideoWord[];
  className?: string;
  highlightIndex: number;
  onWordClick: (clickedWord: UserVideoWord) => void;
  onDoubleWordClick?: (clickedWord: UserVideoWord) => void;
  reviewWord?: UserVideoWord;
}

const ReviewSubtitle: React.FC<ReviewSubtitleProps> = ({
  userVideoWords,
  className,
  highlightIndex,
  onWordClick,
  onDoubleWordClick,
  reviewWord,
}) => {
  return (
    <>
      <TextBoxWithFlag className={className}>
        <Flag>
          <ES title="Spain" className="w-8" />
        </Flag>
        <Text>
          <ReviewHighlightedWords
            words={userVideoWords}
            highlightPosition={highlightIndex}
            onWordClick={onWordClick}
            onDoubleWordClick={onDoubleWordClick || (() => {})}
            reviewWord={reviewWord}
          />
        </Text>
      </TextBoxWithFlag>
    </>
  );
};

export default ReviewSubtitle;
